import script from "./WhatsAppIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsAppIcon.vue?vue&type=script&setup=true&lang=js"

import "./WhatsAppIcon.vue?vue&type=style&index=0&id=5f8f94ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f8f94ba"]])

export default __exports__